export default (function (_ref) {
  var request = _ref.request;
  return {
    smartControlTaskAdd: function smartControlTaskAdd(data) {
      return request({
        url: '/iot/smartControlTask/add',
        method: 'post',
        data: data
      });
    },
    smartControlTaskModify: function smartControlTaskModify(data) {
      return request({
        url: "/iot/smartControlTask/".concat(data.id, "/modify"),
        method: 'put',
        data: data
      });
    },
    smartControlTaskDel: function smartControlTaskDel(id) {
      return request({
        url: "/iot/smartControlTask/".concat(id, "/del"),
        method: 'delete'
      });
    },
    smartControlTaskQuery: function smartControlTaskQuery(data) {
      return request({
        url: '/iot/smartControlTask/query',
        method: 'get',
        params: data
      });
    },
    smartControlTaskDetail: function smartControlTaskDetail(id) {
      return request({
        url: "/iot/smartControlTask/".concat(id, "/detail"),
        method: 'get'
      });
    }
  };
});